import Lenis from 'lenis'

export let scroller = new Lenis({
  autoRaf: true,
  prevent: (node) => node.id === 'cc-main'
});
